export default "__VITE_ASSET__z78iHElA__"